import React from 'react'
import ViewRecieptSection from '../../../component/billing-payments/invoice/reciept/view-reciept/ViewRecieptSection'

function ViewReciept() {
  return (
    <div className='page-body'>
      <ViewRecieptSection/>
    </div>
  )
}

export default ViewReciept
